var i = 0;

(function () {
	$.fn.conter = function (options) {
		options = options || {};

		return $(this).each(function () {
			// set options for current element
			let settings = $.extend({}, $.fn.conter.defaults, {
				from: $(this).data('from'),
				to: $(this).data('to'),
				speed: $(this).data('speed'),
				refreshInterval: $(this).data('refresh-interval'),
				decimals: $(this).data('decimals'),
				suffix: $(this).data('suffix'),
				prefix: $(this).data('prefix'),
				persistantPrefix: $(this).data('persistant-prefix'),
				persistantSuffix: $(this).data('persistant-suffix'),
				formatCharacter: $(this).data('format-character'),
				repeat: $(this).data('repeat'),
				repeatPause: $(this).data('repeat-pause'),
				thisContext: $(this)
			}, options);

			// how many times to update the value, and how much to increment the value on each update
			let loops = Math.ceil(settings.speed / settings.refreshInterval);
			let increment = (settings.to - settings.from) / loops;

			// references & variables that will change with each update
			let self = this;
			let $self = $(this);
			let loopCount = 0;
			let value = settings.from;
			let data = $self.data('conter') || {};

			$self.data('conter', data);

			// if an existing interval can be found, clear it first
			if (data.interval) {
				clearInterval(data.interval);
			}

			data.interval = setInterval(updateTimer, settings.refreshInterval);

			if (i === 0) {
				console.log("timer start " + new Date());
				i++;
			}

			// initialize the element with the starting value
			render(value);

			function updateTimer() {
				value += increment;
				loopCount++;

				render(value);

				if (typeof (settings.onUpdate) === 'function') {
					settings.onUpdate.call(self, value);
				}

				if (loopCount >= loops) {
					// remove the interval
					$self.removeData('conter');
					clearInterval(data.interval);
					data.interval = false;
					value = settings.to;

					if (settings.suffix !== "" || settings.prefix !== "") {
						render(value, true);
					}

					if (typeof (settings.onComplete) === 'function' && settings.repeat === "True") {
						setTimeout(function () { settings.onComplete.call(settings.thisContext, options) }, settings.repeatPause);
					}
				}

				if (data.interval && loopCount >= ((loops / 10) * 9.5)) {
					clearInterval(data.interval);
					data.interval = setInterval(updateTimer, 80);
				}
			}

			function render(value, isFinal) {
				let formattedValue = settings.formatter.call(self, value, settings);

				if (typeof (settings.persistantPrefix) === "boolean" && !settings.persistantPrefix && isFinal && settings.prefix !== "") {
					formattedValue = settings.prefix + formattedValue;
				}

				if (typeof (settings.persistantSuffix) === "boolean" && !settings.persistantSuffix && isFinal && settings.suffix !== "") {
					formattedValue += settings.suffix;
				}

				$self.html(formattedValue);
			}
		});
	};

	$.fn.conter.defaults = {
		from: 0,                 // the number the element should start at
		to: 0,                   // the number the element should end at
		speed: 1000,             // how long it should take to count between the target numbers
		refreshInterval: 5,     // how often the element should be updated
		decimals: 0,             // the number of decimal places to show
		persistantPrefix: false, // show prefix through entire animation
		persistantSuffix: false, // show suffix through entire animation
		suffix: "",              // the suffix to show at the end of the counter
		prefix: "",              // the prefix to show at the start of the counter
		formatCharacter: "",     // the character to use in formatting e.g. "," => "1,700"
		formatter: formatter,    // handler for formatting the value before rendering
		onUpdate: null,          // callback method for every time the element is updated
		onComplete: reset,       // callback method for when the element finishes updating
		repeat: false,           // callback method for when the element finishes updating
		repeatPause: 1000       // callback method for when the element finishes updating
	};

	function reset() {
		count.call($(this));
	}

	function formatter(value, settings) {
		let fixed = typeof (settings.formatCharacter) === "string" ?
			value.toFixed(settings.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, settings.formatCharacter) :
			value.toFixed(settings.decimals);

		if (typeof (settings.persistantPrefix) === "boolean" && settings.persistantPrefix && settings.prefix !== "") {
			fixed = settings.prefix + fixed;
		}

		if (typeof (settings.persistantSuffix) === "boolean" && settings.persistantSuffix && settings.suffix !== "") {
			fixed += settings.suffix;
		}

		return fixed;
	}
})();

(function () {
	// custom formatting example
	// $('.count-number').data('conterOptions', {
	//     formatter: function (value, options) {
	//         return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
	//     }
	// });

	// start all the timers
	$('.timer').each(count);
})();

function count(options) {
	var $this = $(this);
	options = $.extend({}, options || {}, $this.data('conterOptions') || {});
	$this.conter(options);
}